module.exports = __webpack_public_path__ + "static/img/gzTab.449c15d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/gzTab.jpg
// module id = b4SL
// module chunks = 4